// extracted by mini-css-extract-plugin
export default {"unsupported-file":"UnsupportedFile_unsupported-file__YhO53","unsupported-file__txt":"UnsupportedFile_unsupported-file__txt__i9QBI"};